import { cn } from "@/lib/utils";

/**
 * Chuẩn tab EMS: tab dạng thẻ nằm trên một đường kẻ đáy; tab đang chọn là thẻ trắng, chữ đậm màu chính
 * và gạch chân đậm (3px). Dùng chung cho tab module (Kho: Phiếu nhập xuất | Báo cáo NXT…), tab trong trang
 * (Radix Tabs ở components/ui/tabs) và tab thanh công cụ danh sách (Danh sách | Thùng rác…).
 * - size "md": tab module / tab trong trang; size "sm": tab thanh công cụ danh sách (gọn, 2 hàng tiêu đề).
 */
export type EmsTabSize = "sm" | "md";
export type EmsTabTone = "primary" | "rose";

/** Thanh chứa tab: các thẻ đứng trên đường kẻ đáy */
export const EMS_TAB_BAR = "flex items-end gap-1 border-b border-slate-200";

const BASE =
  "relative inline-flex items-center gap-1.5 whitespace-nowrap shrink-0 rounded-t-md border border-b-0 cursor-pointer select-none transition-colors " +
  "after:absolute after:inset-x-0 after:bottom-0 after:h-[3px] after:rounded-t-sm";

const SIZE: Record<EmsTabSize, string> = {
  md: "h-9 px-3.5 text-sm",
  // Thanh công cụ danh sách: lề hẹp để dòng 1 (tab + thao tác) vẫn nằm gọn một hàng
  sm: "h-7 px-1.5 gap-1 text-xs",
};

const ACTIVE: Record<EmsTabTone, string> = {
  primary: "bg-white border-slate-200 font-bold text-primary after:bg-primary",
  rose: "bg-white border-slate-200 font-bold text-rose-700 after:bg-rose-600",
};

const INACTIVE = "border-transparent font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100/70 after:bg-transparent";

export function emsTabClass(active: boolean, opts: { size?: EmsTabSize; tone?: EmsTabTone } = {}) {
  const { size = "md", tone = "primary" } = opts;
  return cn(BASE, SIZE[size], active ? ACTIVE[tone] : INACTIVE);
}

/** Cùng kiểu cho Radix Tabs (trạng thái chọn qua data-[state=active]) */
export const EMS_RADIX_TRIGGER =
  `${BASE} ${SIZE.md} border-transparent font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100/70 after:bg-transparent ` +
  "data-[state=active]:bg-white data-[state=active]:border-slate-200 data-[state=active]:font-bold data-[state=active]:text-primary data-[state=active]:after:bg-primary " +
  "disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 " +
  "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";
